import type { ReactNode } from "react";
import { X } from "lucide-react";
import { useT } from "@ec2/i18n/react";

/** Bottom result sheet (brief: 28px top radius, slides over the frozen frame). */
export function Sheet({
  label,
  onClose,
  children,
}: {
  label: string;
  onClose?: () => void;
  children: ReactNode;
}) {
  const t = useT();
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={label}
      data-testid="ec-sheet"
      className="fixed inset-x-0 bottom-0 z-50 mx-auto max-w-md rounded-t-(--radius-sheet) border-t border-border bg-surface-raised pb-[env(safe-area-inset-bottom)] shadow-2xl"
    >
      {onClose && (
        <button
          type="button"
          onClick={onClose}
          aria-label={t("ec2.common.close")}
          data-testid="ec-sheet-close"
          className="absolute right-3 top-3 z-10 flex size-9 items-center justify-center rounded-full bg-surface-overlay text-fg-secondary focus-visible:outline-2 focus-visible:outline-primary"
        >
          <X size={18} aria-hidden />
        </button>
      )}
      <div className="px-5 pb-6 pt-5">{children}</div>
    </div>
  );
}
